module.exports = __webpack_public_path__ + "img/background067.7d9fcc80.jpg";